import React, { useState } from "react";
import { Stack, Switch, Typography } from "@mui/material";
import Codebox from "components/common/Codebox";
import { useAuth } from "hooks/useAuth";

export default function AccessDocumentWidgetBody() {
  const { user } = useAuth();
  const [logoBranding, setLogoBranding] = useState(true);
  const REACT_APP_BASE_URL = "https://portal.itscredible.com";
  const VERIFICATION_WIDGET_CODE = `<div 
  id="vmVerificationWidget" 
  data-widget-key="${user.companyId}" 
  data-widget-branding="${logoBranding}" 
  ></div>
<script src="${REACT_APP_BASE_URL}/library.js"></script>`;

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1} mt={1}>
        <Typography variant="body1">ItsCredible logo on the widget</Typography>
        <Switch
          checked={logoBranding}
          onChange={() => setLogoBranding((prevState) => !prevState)}
        />
      </Stack>
      <Codebox mt={2}>{VERIFICATION_WIDGET_CODE}</Codebox>
    </>
  );
}
